import "./Popup.css";

import { Button, InputAdornment, TextField } from "@mui/material";
import React, { useState } from "react";

import PostAddIcon from "@mui/icons-material/PostAdd";

const Popup = ({ verify, hide, message }) => {
  const [text, setText] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmedText = text.trim(); // Trim the text 

    if (trimmedText) { 
      verify(trimmedText); 
      setTimeout(() => {
        hide(false);
      }, 1000);
    } 
  };
  return (
    <>
      <nav className="popup-container">
        <div className="popup-popup">
          <div className="popup-cross" onClick={() => hide(false)}>
            X
          </div>
          <span>Enter the folder name:</span>
          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="popup-email">
              <TextField
                fullWidth
                required
                inputProps={{ maxLength: 40 }}
                value={text}
                label="Name"
                variant="outlined"
                type="text"
                onChange={(e) => setText(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PostAddIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className="popup-submit">
              <Button
                type="submit"
                fullWidth
                variant="contained"
                style={{ background: "#446fa2" }}
              >
                CREATE
              </Button>
            </div>
          </form>
        </div>
      </nav>
    </>
  );
};

export default Popup;
